import { render, staticRenderFns } from "./download-confirmation.vue?vue&type=template&id=35ae938a&"
import script from "./download-confirmation.vue?vue&type=script&lang=js&"
export * from "./download-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./download-confirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ae938a')) {
      api.createRecord('35ae938a', component.options)
    } else {
      api.reload('35ae938a', component.options)
    }
    module.hot.accept("./download-confirmation.vue?vue&type=template&id=35ae938a&", function () {
      api.rerender('35ae938a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-list/download-confirmation.vue"
export default component.exports